{
    "firebase": {
        "apiKey": "AIzaSyAsnokt7beqnidxzHpDU1yc3GFrzmq9yy0",
        "authDomain": "flightline-madison-prod.firebaseapp.com",
        "databaseURL": "https://flightline-madison-prod-default-rtdb.firebaseio.com",
        "projectId": "flightline-madison-prod",
        "storageBucket": "flightline-madison-prod.firebasestorage.app",
        "messagingSenderId": "161215752472",
        "appId": "1:161215752472:web:0057d401a28dfa95ad566d"
    },
    "clientName": "25madison",
    "pdfViewerKey": "384fff5edfe5436e8177480ebd9667f0",
    "domains": ["25madison.flightlinedata.com"]
}
